<template>
  <div class="overview">
    <!-- Stats Row -->
    <section class="stats">
      <div class="stat-card">
        <h2>Conversion Rate</h2>
        <div class="stat-details">
          <p class="main-value">0.51%</p>
          <p class="sub-value">1.1%</p>
          <i class="fa-solid fa-arrow-up"></i>
          <p class="trend">than last week</p>
        </div>
        <div class="img-wrap">
          <img
            src="../../assets/images/admin_images/convrate.png"
            alt="Conversion Rate"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      <div class="stat-card">
        <h2>Sale Growth Rate</h2>
        <div class="stat-details">
          <p class="main-value">4,124</p>
          <p class="sub-value">1.1%</p>
          <i class="fa-solid fa-arrow-down"></i>
          <p class="trend">than last week</p>
        </div>
        <div class="img-wrap">
          <img
            src="../../assets/images/admin_images/salegrowth.png"
            alt="Sale Growth Rate"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      <div class="stat-card">
        <h2>Cart Abandonment Rate</h2>
        <div class="stat-details">
          <p class="main-value">2.51%</p>
          <p class="sub-value">1.1%</p>
          <i class="fa-solid fa-arrow-up"></i>
          <p class="trend">than last week</p>
        </div>
        <div class="img-wrap">
          <img
            src="../../assets/images/admin_images/Cartabandon.png"
            alt="Cart Abandonment Rate"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>

    <!-- Returns & Sales -->
    <section class="returns-sales">
      <MarketReturns class="returns-chart" />

      <div class="sales-overview">
        <h2>Sales Overview</h2>
        <div class="sales-item">
          <div>
            <p class="item-name">Basketball</p>
            <p class="item-time">5 hours ago</p>
          </div>
          <p class="item-amount positive">+4,500</p>
        </div>
        <div class="sales-item">
          <div>
            <p class="item-name">Baseball Bat</p>
            <p class="item-time">23 hours ago</p>
          </div>
          <p class="item-amount negative">-300</p>
        </div>
        <div class="sales-item">
          <div>
            <p class="item-name">Dumbbells</p>
            <p class="item-time">2 days ago</p>
          </div>
          <p class="item-amount positive">+13,000</p>
        </div>
        <h2>Total Sales</h2>
        <progress value="40" max="100"></progress>
      </div>

      <div class="earnings">
        <h2>Earnings</h2>
        <div class="top-item">
          <div class="product-info">
            <div class="product-img product-img--placeholder" aria-hidden="true">
              <i class="fa-solid fa-box"></i>
            </div>
            <p class="product-price">Ksh 2,500</p>
          </div>
          <progress class="product-progress" value="40" max="100"></progress>
        </div>

        <div class="top-item">
          <div class="product-info">
            <div class="product-img product-img--placeholder" aria-hidden="true">
              <i class="fa-solid fa-box"></i>
            </div>
            <p class="product-price">Ksh 4,500</p>
          </div>
          <progress class="product-progress" value="80" max="100"></progress>
        </div>

        <div class="top-item">
          <div class="product-info">
            <div class="product-img product-img--placeholder" aria-hidden="true">
              <i class="fa-solid fa-box"></i>
            </div>
            <p class="product-price">Ksh 4,500</p>
          </div>
          <progress class="product-progress" value="50" max="100"></progress>
        </div>

        <div class="top-item">
          <div class="product-info">
            <div class="product-img product-img--placeholder" aria-hidden="true">
              <i class="fa-solid fa-box"></i>
            </div>
            <p class="product-price">Ksh 10,500</p>
          </div>
          <progress class="product-progress" value="50" max="100"></progress>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MarketReturns from '../../components/adminpage/others/returnschart.vue'

export default {
  name: 'OverView',
  components: { MarketReturns }
}
</script>

<style scoped>
.overview {
  width: 100%;
  background-color: var(--background-color1);
  color: var(--text-color1);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

/* Stats Section */
.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 0.8rem;
  padding: 0.8rem;
}

.stat-card {
  background: var(--background-color2);
  border-radius: 6px;
  padding: 0.8rem;
  text-align: center;
  height: auto;
}

.stat-details {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  flex-wrap: wrap;
}

h2 {
  font-size: 0.9rem;
  color: var(--text-color2);
  text-align: left;
  margin-bottom: 4px;
}

.main-value {
  font-size: 0.9rem;
  font-weight: 500;
}
.sub-value,
.trend {
  font-size: 0.6rem;
}

.img-wrap {
  display: flex;
  justify-content: center;
  margin-top: 0.4rem;
}

.img-wrap img {
  width: 100%;
  max-width: 200px;
  height: auto;
}

/* Returns & Sales */
.returns-sales {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  padding: 0.8rem;
  background: var(--background-color2);
  border-radius: 6px;
}

.returns-chart {
  flex: 1 1 280px;
}

.sales-overview {
  flex: 1 1 280px;
  background: var(--background-color3);
  border-radius: 6px;
  padding: 0.8rem;
}

.sales-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.4rem;
  font-size: 0.75rem;
}

.item-name {
  font-size: 0.75rem;
}
.item-time {
  font-size: 0.6rem;
  opacity: 0.8;
}
.item-amount {
  font-weight: 500;
  font-size: 0.75rem;
}
.item-amount.positive {
  color: #4caf50;
}
.item-amount.negative {
  color: #f44336;
}

/* Earnings */
.earnings {
  flex: 1 1 220px;
  background: var(--background-color3);
  border-radius: 6px;
  padding: 0.8rem;
}

.top-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.7rem;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.product-img {
  width: 45px;
  height: 45px;
  border-radius: 4px;
}

.product-img--placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--background-color1);
  border: 1px dashed rgba(255, 255, 255, 0.15);
  color: var(--text-color2);
  font-size: 1rem;
}

.product-price {
  font-size: 0.65rem;
}

progress {
  width: 100%;
  height: 5px;
  border-radius: 20px;
  overflow: hidden;
  appearance: none;
}

progress::-webkit-progress-bar {
  background-color: #e0e0e0;
}
progress::-webkit-progress-value {
  background: linear-gradient(90deg, #4caf50, #81c784);
}
progress::-moz-progress-bar {
  background: linear-gradient(90deg, #4caf50, #81c784);
}

/* Responsive */
@media (max-width: 768px) {
  .returns-sales {
    flex-direction: column;
  }
}
</style>
